import styled from 'styled-components';

export const StyledTermsAndConditionsPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
`;
